import { SkeletonTheme as DefaultSkeletonTheme } from 'react-loading-skeleton'

const SkeletonTheme: React.ReactFCWithChildren = ({ children }) => {
  return (
    <DefaultSkeletonTheme baseColor="#f8f7f4" highlightColor="#9f9f9f">
      {children}
    </DefaultSkeletonTheme>
  )
}

export default SkeletonTheme
